import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import CustomDialog from '../CustomDialog';
import { Button, Typography, Box } from '@mui/material';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { useAppSelector } from '../../hooks/useAppSelector';
import { acceptTerms } from '../../store/slices/auth';
import { unsetPathBeforeLoginRequest } from '../../store/slices/sessionStatus';

const AcceptTerms = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const auth = useAppSelector((state) => state.auth);
    const sessionStatus = useAppSelector((state) => state.sessionStatus);
    const { tokenData } = auth;
    const { pathBeforeLoginRequest } = sessionStatus;

    useEffect(() => {
        if (tokenData?.data?.terms) {
            if (pathBeforeLoginRequest) {
                history.push(pathBeforeLoginRequest);
                dispatch(unsetPathBeforeLoginRequest());
            } else {
                history.push('/');
            }
        }
    }, [tokenData?.data?.terms]);

    const handleAccept = () => {
        void dispatch(acceptTerms());
    };

    return (
        <CustomDialog
            title={'Terms & Conditions'}
            isModal={true}
        >
            <Box sx={{ maxHeight: '40vh', overflowY: 'auto', mb: 3, pr: 1 }}>
                <Typography variant="body1" paragraph>
                    Welcome to KwadHub! By accepting these terms, you agree to be bound by the following conditions,
                    which govern your use of the site and all of its features, content, and services.
                </Typography>
                <Typography variant="body1" paragraph>
                    <strong>1. Use of the Site:</strong> KwadHub is a platform that allows users to share spots where
                    they can fly quadcopters and other UAVs. By using this site, you agree to use it only for lawful
                    purposes and in compliance with all applicable laws and regulations.
                </Typography>
                <Typography variant="body1" paragraph>
                    <strong>2. User Content:</strong> By uploading content, you grant KwadHub a non-exclusive,
                    worldwide, royalty-free license to use, modify, distribute, and display the content in connection
                    with the site and its services.
                </Typography>
                <Typography variant="body1" paragraph>
                    <strong>3. Liability:</strong> KwadHub does not guarantee the accuracy of any content on the site
                    and is not responsible for any loss, damage, or injury arising from use of the site or its services.
                </Typography>
                <Typography variant="body1" paragraph>
                    <strong>4. Intellectual Property:</strong> All content and materials on the site are the property
                    of KwadHub or its licensors. You may not use any content without express written consent.
                </Typography>
                <Typography variant="body1" paragraph>
                    <strong>5. Indemnification:</strong> You agree to hold KwadHub harmless from any claim arising out
                    of your use of the site or your violation of these terms.
                </Typography>
                <Typography variant="body1">
                    By clicking Accept, you acknowledge that you have read, understood, and agree to be bound by these
                    terms and conditions.
                </Typography>
            </Box>
            <Box sx={{ textAlign: 'center' }}>
                <Button variant='contained' onClick={handleAccept}>
                    I accept the terms & conditions
                </Button>
            </Box>
        </CustomDialog>
    );
};

export default AcceptTerms;
